import { Injectable, Signal } from '@angular/core';
import { IOnlineUseData, IOnlineUseModel } from '@partners/api';
import { Observable } from 'rxjs';
import { StateAccessService } from '../../../services';
import { IOnlineUseState, OnlineUseActions, OnlineUseSelectors } from '../store';

@Injectable({
  providedIn: 'root'
})
export class OnlineUseStore extends StateAccessService<IOnlineUseState> {
  readonly state$: Observable<IOnlineUseState>;

  readonly data$$: Signal<IOnlineUseData>;
  readonly model$$: Signal<IOnlineUseModel>;

  constructor() {
    super();

    this.model$$ = this.stateFacade.selectSignal$(OnlineUseSelectors.model);
    this.data$$ = this.stateFacade.selectSignal$(OnlineUseSelectors.data);
  }

  dispatchOnlineUseReset() {
    this.stateFacade.dispatch(OnlineUseActions.reset());
  }
  dispatchOnlineUseLoad() {
    this.stateFacade.dispatch(OnlineUseActions.load());
  }
  dispatchOnlineUseLoadSuccess({ model, data }: { model: IOnlineUseModel; data: IOnlineUseData }) {
    this.stateFacade.dispatch(OnlineUseActions.loadSuccess({ model, data }));
  }
}
